import styled, { css } from 'styled-components';

export const CircleGraphLabel = styled.div`
  position: relative;
  width: 200px;
  margin: 0 auto;
  text-align: center;

  & > div {
    position: absolute;
    z-index: 10;
  }

  & > div.minValue {
    width: 20px;
    left: 10px;
    top: 120px;
    color: #ddd;
    font-size: 12px;
  }

  & > div.circleLabel {
    width: 200px;
    top: 120px;
    color: #fff;
    font-size: 15px;
  }

  & > div.dataLabel {
    width: 200px;
    top: 70px;
    color: #fff;
    font-size: 35px;

    ${props => 
      props.status === "warning" ? css`color: #ffff07;` : (
        props.status === "danger" && css`color: #ff2807;`
      )
    }
  }

  & > div.maxValue {
    width: 20px;
    right: 10px;
    top: 120px;
    color: #ddd;
    font-size: 12px;
  }
`;

export const CriterionLine = styled.div`
  width: 250px;
  height: 250px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  font-size: 8px;

  ${props =>
    css`
      color: ${props.standType === 'danger' ? '#ff2807' : '#ffa407'}
    `
  }

  ${props => 
    css`
      transform: rotate(
        ${props.value * 180 >= 0 && props.value * 180 <= 180 ? Math.round(180 - props.value * 180) : 
            (props.value * 180 > 180 ? 180 : 0)}deg);
      left: 
        ${props.value >= 0 && props.value <= 1 ? Math.round(props.value * -5 - 20) : 
            (props.value > 1 ? -25 : -20)}px;
      top: -12px;
    `
  }

  & > span {
    ${props =>
      css`
        transform: rotate(${props.value * 180 < 90 ? 180 : 0}deg);
      `
    }
  }
`